"use client";

import { useId } from "react";
import { MemoizedMarkdown } from "@/components/ui/MemoizedMarkdown";
import { looksLikeTelegramHtml } from "../detect";
import { telegramHtmlToMarkdown } from "../markdown-dialects";
import { PRIORITY, type ValueRenderer } from "../types";

const TELEGRAM_NODE_RE = /telegram/i;

export const TelegramHtmlRenderer: ValueRenderer = {
  id: "telegram-html",
  match: (value, ctx) => {
    if (typeof value !== "string") return null;
    const nodeHint = ctx.nodeType != null && TELEGRAM_NODE_RE.test(ctx.nodeType);
    // On a Telegram node this dialect renderer must outrank the generic
    // MarkdownRenderer (also CONTEXT_HINTED on content keys) — otherwise the
    // raw HTML under an `output` key would reach MarkdownRenderer unconverted.
    if (nodeHint && looksLikeTelegramHtml(value)) {
      return { priority: PRIORITY.CONTEXT_HINTED + 1, confidence: "high" };
    }
    if (looksLikeTelegramHtml(value)) return { priority: PRIORITY.CONTENT_SNIFFED, confidence: "high" };
    return null;
  },
  Component: ({ value }) => {
    const id = useId();
    return (
      <div className="text-sm">
        <MemoizedMarkdown content={telegramHtmlToMarkdown(value as string)} id={id} />
      </div>
    );
  },
};
